import { render, staticRenderFns } from "./planList.vue?vue&type=template&id=f388191a&scoped=true"
import script from "./planList.vue?vue&type=script&lang=js"
export * from "./planList.vue?vue&type=script&lang=js"
import style0 from "./planList.vue?vue&type=style&index=0&id=f388191a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f388191a",
  null
  
)

export default component.exports